module.exports = __webpack_public_path__ + "img/discount-promo.8235116f.svg";